export default "__VITE_ASSET__BwnrM9kL__"